import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { viewModelToPlanCustomMailSettingInputConverter } from "./composition/view-model-to-plan-custom-mail-setting-input";
import { viewModelToPlanInputConverter } from "./composition/view-model-to-plan-input";
import { PlanUpdateMutation } from "./mutation";

import type { ProductPlanFormModel } from "../../../type";

type Props = {
	reset: () => void;
};

export const usePlanEditMutation = ({ reset }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(PlanUpdateMutation);

	const onUpdate = useCallback(
		async (
			planViewModel: ProductPlanFormModel["ViewModel"], //
		) => {
			showLoadingScreenCallback();

			try {
				const planInput = viewModelToPlanInputConverter({ viewModel: planViewModel });
				const planCustomMailSettingInput = viewModelToPlanCustomMailSettingInputConverter({
					viewModel: planViewModel,
				});

				// プラン更新
				const { errors: planErrors } = await mutationFunc({
					variables: {
						input: planInput,
						planCustomMailSettingInput: planCustomMailSettingInput,
					},
				});

				if (planErrors) {
					return;
				}
				notifyUserEventInfo({
					variant: "default",
					title: "プランを更新しました",
				});

				reset();
			} finally {
				hideLoadingScreenCallback();
			}
		},
		[hideLoadingScreenCallback, mutationFunc, reset, showLoadingScreenCallback],
	);

	return { onUpdate };
};
